export default {
  template: "#vue-collection-topline",
  delimiters: ["${", "}"],
  methods: {
    handleSort(event) {
      Shopify.queryParams = {};
      if (location.search.length) {
        for (
            var aKeyValue, i = 0, aCouples = location.search.substring(1).split("&");
            i < aCouples.length;
            i++
        ) {
          aKeyValue = aCouples[i].split("=");
          if (aKeyValue.length > 1) {
            Shopify.queryParams[
                decodeURIComponent(aKeyValue[0])
                ] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
      Shopify.queryParams.sort_by = event.target.value;
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    },
  }
}